var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from "react";
import classNames from "classnames";
var Badge = forwardRef(function (_a, ref) {
    var label = _a.label, _b = _a.as, Component = _b === void 0 ? "p" : _b, _c = _a.size, size = _c === void 0 ? "md" : _c, noIcon = _a.noIcon, system = _a.system, color = _a.color, taille = _a.taille, sansIcone = _a.sansIcone, couleur = _a.couleur, className = _a.className, style = _a.style, otherProps = __rest(_a, ["label", "as", "size", "noIcon", "system", "color", "taille", "sansIcone", "couleur", "className", "style"]);
    var classBadge = classNames(className === undefined ? "" : className, "fr-badge");
    /**
     * @deprecated Supprimé dans une future Release d'ici fin 2025.
     */
    if (color === undefined && couleur !== undefined) {
        color = couleur;
    }
    if (color) {
        classBadge += " fr-badge--" + color;
    }
    /**
     * @deprecated Supprimé dans une future Release d'ici fin 2025.
     */
    if (size === "sm" || taille === "sm") {
        classBadge += " fr-badge--sm";
    }
    /**
     * @deprecated Supprimé dans une future Release d'ici fin 2025.
     */
    if (system) {
        classBadge += " fr-badge--" + system;
        if (noIcon || sansIcone) {
            classBadge += " fr-badge--no-icon";
        }
    }
    return (React.createElement(Component, __assign({}, otherProps, { 
        // @ts-expect-error ref peut-être pour un p ou un span
        ref: ref, className: classBadge, style: style }), label));
});
export default Badge;
